<template>
  <div>
    <div class="ed-itemTabs clr">
      <template v-if="item._childDocuments_">
        <span
          v-for="(fairEvent, index) in filtered_chilDocuments"
          :key="index"
          :style="{ backgroundColor: fairEvent.av_fair_theme_color,
          color: fairEvent.av_fair_contrast_color }"
          class="ed-itemTab ed-itemTab--fairEvent">
          {{ fairEvent.fair_title }}
        </span>
      </template>
      <!--v-for="tabFeature in item.tabFeature"-->
      <!--:key="tabFeature.name"-->
      <!--class="ed-itemTab ed-itemTab&#45;&#45;feature">-->
      <!--{{tabFeature.name}}-->
      <!--</span>-->
      <template v-if="item.av_badges">
        <template v-for="(badge, index) in item.av_badges">
          <span
            :key="index"
            class="ed-itemTab ed-itemTab--feature"
            v-if="badge.type === 0">
          {{ badge.title }}
        </span>
        </template>
      </template>
    </div>
    <div class="ed-grid">
      <div class="ed-grid__item ed-grid__item--1">
        <template v-if="item.type === getExhibitorType">
          <img
            v-if="item.av_logo"
            class="ed-item__logo ed-item__logo--link"
            :src="item.av_logo"
            @click="updateRoute(item)"
            aria-haspopup="true"
            :title="$t('list.linkToDetailTooltip')"
            :alt="item.title"/>
        </template>
        <template v-else-if="item.type === getNewsType">
          <img
            v-if="item.av_news_image_url"
            class="ed-item__logo ed-item__logo--link"
            :src="item.av_news_image_url"
            @click="updateRoute(item)"
            aria-haspopup="true"
            :title="$t('list.linkToDetailTooltip')"
            :alt="item.title"/>
        </template>
        <template v-else>
          <img
            v-if="item.av_logo"
            class="ed-item__logo"
            :src="item.av_logo"
            :alt="item.title"/>
        </template>
      </div>
      <div class="ed-grid__item ed-grid__item--2">
        <div class="ed-text">
          <span class="ed-text__small">
            {{ returnItemType(item.type) }}
            <template v-if="item.boothsInFair">
              <template v-for="(booth, index) in item.boothsInFair">
                <template v-if="index === 0"> | </template>
                <template v-if="index < 5">
                  <template v-if="hallplan_path">
                    <a
                      :key="index"
                      class="ed-text__link--hallplan"
                      :title="$t('list.linkToHallPlan')"
                      :href="generateHallplanLink(booth)">
                      <template v-if="booth.hall.title !== $t('detail.fairBooths.undefined')">
                        {{ booth.hall.title }},
                      </template>
                      {{ $t('detail.fairBooths.booth') }} {{ getBoothName(booth) }}</a>
                    <template v-if="booth.ebmsState">, {{
                        $t(`detail.fairBooths.ebmsState.${booth.ebmsState}`)
                      }}</template>
                    <template v-if="!isLastElement(index, item.boothsInFair)">;</template>
                  </template>
                  <template v-else>
                    <template v-if="booth.hall.title !== $t('detail.fairBooths.undefined')">
                      {{ booth.hall.title }},
                    </template>
                    {{ $t('detail.fairBooths.booth') }} {{ getBoothName(booth) }}
                    <template v-if="booth.ebmsState">, {{
                        $t(`detail.fairBooths.ebmsState.${booth.ebmsState}`) }}</template>
                    <template
                      v-if="!isLastElement(index, item.boothsInFair)">; </template>
                  </template>
                </template>
              </template>
              <template v-if="item.boothsInFair.length > 5" > [...]</template>
            </template>
            <template v-if="item.type === getNewsType">
              | {{ item.date | moment('DD.MM.YYYY') }} | {{ item.av_exhibitor_object.name }}
            </template>
          </span>
          <template v-if="item.type === getExhibitorType">
            <h3
              v-if="item.title"
              class="ed-text__title ed-text__title--link"
              @click="updateRoute(item)"
              aria-haspopup="true"
              :title="$t('list.linkToDetailTooltip')">
              {{ item.title }}
            </h3>
          </template>
          <template v-else>
            <h3
              v-if="item.title"
              class="ed-text__title">
              {{ item.title }}
            </h3>
          </template>
          <template v-if="view_size_mode !== 0 && item.content">
            <div class="ed-text__description">
              <p>{{ item.content | crop(200, '...') }}</p>
            </div>
          </template>
          <template v-else-if="view_size_mode !== 0 && item.av_zip && item.av_city">
            <div class="ed-text__description">
              <p>{{ item.av_zip }} {{ item.av_city }}<template v-if="item.av_country">, {{
                  item.av_country
                }}</template></p>
            </div>
          </template>
        </div>
      </div>
      <div class="ed-grid__item ed-grid__item--3">
        <div
          class="ed-item__features"
          v-if="view_size_mode !== 0 && item.av_badges">
          <img
            v-for="badge in item.av_badges"
            :key="badge.id"
            :title="badge.title"
            :alt="badge.title"
            :src="badge.graphic">
        </div>
      </div>
    </div>
    <template v-if="item.type === getExhibitorType">
      <a
        @click="updateRoute(item)"
        class="ed-item__detailLink button"
        aria-haspopup="true"
        :title="$t('list.linkToDetailTooltip')">
        {{ $t('list.linkToDetail') }}
      </a>
    </template>
    <template v-else-if="item.type === getNewsType">
      <a
        @click="updateRoute(item)"
        class="ed-item__detailLink button"
        aria-haspopup="true"
        :title="$t('list.linkToNewsDetailTooltip')">
        {{ $t('list.linkToNewsDetail') }}
      </a>
    </template>
    <button
      @click="setFavourite(item.id)"
      class="ed-item__favourite button"
      v-if="!terminalmode"
      :class="{ 'ed-item__favourite--active': is_favourite }"
      :aria-pressed="is_favourite"
      :title="
      is_favourite ?
      $t('list.favouriteTooltip.detail.active') : $t('list.favouriteTooltip.detail.inactive')">
      <i class="icon icon-star"></i>
    </button>
  </div>
</template>

<script>
import {
  SolrBrandTypeName,
  SolrExhibitorTypeName,
  SolrNewsTypeName,
  SolrProductTypeName
} from '@/common/Utility';
import HallsService from '@/common/halls.service';

export default {
  name: 'ListItem',
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    is_favourite: {
      type: Boolean,
      required: true,
    },
    hallplan_path: {
      type: String,
      required: true,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    filtered_chilDocuments: {
      type: Array,
      required: true,
    },
  },
  computed: {
    getExhibitorType() {
      return SolrExhibitorTypeName;
    },
    getNewsType() {
      return SolrNewsTypeName;
    },
  },
  methods: {
    setFavourite(itemId) {
      this.$emit('setFavourite', itemId);
    },
    updateRoute(item) {
      this.$emit('updateRoute', item);
    },
    getHallNumber(hallId) {
      return HallsService.getHallNumber(hallId);
    },
    getBoothName(booth) {
      const splittedIdentifier = booth.importBoothIdentifier.split(':');
      if (splittedIdentifier.length === 2) {
        return splittedIdentifier[1];
      }
      return '';
    },
    generateHallplanLink(booth) {
      // Not quite sure whether this works yet, so the other part is still commented
      const splittedIdentifier = booth.importBoothIdentifier.split(':');
      if (splittedIdentifier.length === 2) {
        const hallId = splittedIdentifier[0];
        const boothId = splittedIdentifier[1];
        return `${this.hallplan_path}#/${hallId}/${boothId}`;
      }

      return this.hallplan_path;

      // const fullHallId = booth.hallId;
      // // FIXME: this is a workaround for the unexpected behaviour of a
      // // booth having an already "complete" (url ready) boothId
      // const matchesCompleteBoothId = booth.boothId.match(/(\d+)([A-Z])(\d+)(\.(\d+))?/g);
      // if (matchesCompleteBoothId && matchesCompleteBoothId.length > 0
      //   && matchesCompleteBoothId[0] === booth.boothId) {
      //   return `${this.hallplan_path}#/${fullHallId}/${booth.boothId}`;
      // }
      // // code for expected behaviour
      // const hallId = fullHallId.replace(/\D/g, '');
      // const aisleLetter = booth.aisleLetter ? booth.aisleLetter : '';
      // return `${this.hallplan_path}#/${fullHallId}/${hallId}${aisleLetter}${booth.boothId}`;
    },
    returnItemType(type) {
      switch (type) {
        case SolrExhibitorTypeName:
          return this.$t('list.type.exhibitor');
        case SolrProductTypeName:
          return this.$t('list.type.product');
        case SolrNewsTypeName:
          return this.$t('list.type.news');
        case SolrBrandTypeName:
          return this.$t('list.type.brand');
        default:
          return '';
      }
    },
    isLastElement(index, field) {
      return index === field.length - 1;
    },
  },
};
</script>
